import * as React from 'react';
import classnames from 'classnames';
import Text, { Props as TextProps } from '../Text/Text';

export interface Props extends TextProps {
  /** Sets the styling to indicate that the tab is active. */
  active?: boolean;
}

/**
 * Individual navigation item component that should be a direct
 * descendant of the Tabs component.
 */
const Tab: React.FunctionComponent<Props> = (props: Props) => {
  const { active, ...rest } = props;
  const classes = classnames('Tabs__tab', {
    'Tabs__tab--active': active,
  });

  return (
    <Text { ...rest }
        className={ classes }
        letterSpacing="x2"
        uppercase
        weight={ active ? 'bold' : 'medium' } />
  );
};

export default Tab;
